/** CUI guatemalteco (13 dígitos) — validación módulo 11 (8 correlativos + verificador + 4 depto/muni). */
export function esCuiValido(cui: string | null | undefined): boolean {
  if (!cui) return false;
  const v = cui.replace(/\s+/g, '');
  if (!/^\d{13}$/.test(v)) return false;
  const correlativo = v.slice(0, 8);
  const verificador = Number(v.charAt(8));
  let suma = 0;
  for (let i = 0; i < 8; i++) suma += Number(correlativo[i]) * (i + 2);
  const modulo = suma % 11;
  return modulo !== 10 && modulo === verificador;
}

/** Genera CUI válido a partir de 8 dígitos correlativos + sufijo dept/muni (default 0101). */
export function cuiDemo(correlativo8: string, suffix = '0101'): string {
  if (!/^\d{8}$/.test(correlativo8)) throw new Error(`correlativo inválido: ${correlativo8}`);
  let suma = 0;
  for (let i = 0; i < 8; i++) suma += Number(correlativo8[i]) * (i + 2);
  const modulo = suma % 11;
  if (modulo === 10) throw new Error(`correlativo sin dígito verificador: ${correlativo8}`);
  return `${correlativo8}${modulo}${suffix}`;
}
